import Events from '@/events/Events';
import {prepareApiUrl} from '@/helper/UrlHelper';
export default {
  props: {
    organization: {
      type: Object,
      require: false,
      default: () => {},
    },
    buttonType: {
      type: String,
      require: true,
      default: 'extended',
    },
    iconColor: {
      type: String,
      require: false,
      default: 'primaryYellow',
    },
  },
  data() {
    return {
      totalNumberOfRatings: 0,
      rated: null,
    };
  },
  computed: {
    logoUrl() {
      return prepareApiUrl(process.env.NUXT_ENV_LEGACY_AGENCY_LOGO_URL, {
        routeParameters: {
          id: this.organization.id,
        },
        getParameters: {},
      });
    },
  },
  watch: {
    organization: {
      deep: true,
      handler() {
        this.setUpValues();
      },
    },
  },
  created() {
    this.setUpValues();
  },
  methods: {
    setUpValues() {
      this.rated = this.organization.userRating;
      this.totalNumberOfRatings = this.organization.ratingCount;
    },
    async giveStar() {
      await this.$store
        .dispatch('api/starRatings/giveStar', {
          candidateAccountId: this.$auth.user.id,
          organizationId: this.organization.id,
          rating: 5.0,
        })
        .then(() => {
          this.$notifications.showNotification({
            message: this.$t('rating.success'),
            color: 'success',
            timeout: 3000,
          });
          this.$emitWithClientData(Events.OrganizationStared, {
            candidateAccountId: this.$auth.user.id,
            organizationId: this.organization.id,
            rating: 5,
          });
          this.totalNumberOfRatings += 1;
          this.rated = 5;
          this.$emit('star-added');
          this.$auth.fetchUser();
        })
        .catch((e) => {
          if (e.response.status !== 204) {
            e.response.data.violations.map((violation) => {
              if (
                violation.code === '2a25ceb5-2cd0-5ac8-1da2-106178c071cd' ||
                violation.code === 'a4595f5f-cfd2-da50-6a99-d2f348cc4179'
              ) {
                this.$notifications.showNotification({
                  message: this.$t('rating.error_giving_star'),
                  color: 'error',
                  timeout: 3000,
                });
                throw e;
              }
              if (violation.code === '23bd9dbf-6b9b-41cd-a99e-4844bcf3077f') {
                this.$notifications.showNotification({
                  message: this.$t('rating.error_giving_star_already_rated'),
                  color: 'error',
                  timeout: 3000,
                });
                throw e;
              }
            });
          }
        });
    },
    async removeStar() {
      await this.$store
        .dispatch('api/candidateAccount/getStarRatings', {
          id: this.$auth.user.id,
        })
        .then((response) => {
          response.data.map(async (rating) => {
            if (rating.organization.id === this.organization.id) {
              await this.$store
                .dispatch('api/starRatings/removeStar', {
                  id: rating.id,
                })
                .then(() => {
                  this.$notifications.showNotification({
                    message: this.$t('rating.removed'),
                    color: 'success',
                    timeout: 3000,
                  });
                  this.$emitWithClientData(Events.OrganizationUnstared, {
                    organizationId: this.organization.id,
                  });
                  this.totalNumberOfRatings = this.totalNumberOfRatings - 1;
                  this.rated = null;
                  this.$emit('star-removed');
                  this.$auth.fetchUser();
                })
                .catch((e) => {
                  if (e.response.status !== 204) {
                    this.$notifications.showNotification({
                      message: this.$t('rating.error_removing_star'),
                      color: 'error',
                      timeout: 3000,
                    });
                  }
                  throw e;
                });
            }
          });
        });
    },
    updateRating() {
      if (!this.$auth.loggedIn) {
        this.$notifications.showNotification({
          message: this.$t('action.user_not_logged'),
          color: 'error',
          timeout: 3000,
        });
      } else {
        if (this.rated) {
          this.removeStar();
        } else {
          this.giveStar();
        }
      }
    },
  },
};
